<!--
To have
- A group of checkboxes for filters
- Display of all data depending on the filters selected
To do
- To display all data available on initial mounting of the component
- To changed data being displayed based on search keyword and filters selected
-->
<template>
  <div class="tcu-article _content tcu-full-width">
    <header class="tcu-program-filter">
      <div class="tcu-program-filter-heading tcu-visually-hidden">
        <div class="tcu-search _label">
          <label
            class="screen-reader-text tcu-visuallyhidden tcu-searchform__label"
            for="program-keyword-search"
          >Search for:</label>
          <input
            class="tcu-searchform__text"
            type="search"
            value
            name="s"
            id="program-keyword-search"
            placeholder="Search All Majors & Programs"
            v-model="search"
            v-on:keyup="getfilteredData"
          >
        </div>
      </div>

      <div class="tcu-program-filter-list">
        <div class="filter _label">
          Filters
          <img
            height="20"
            width="20"
            alt="Open Accordion"
            class="tcu-down-arrow"
            src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='27px' height='17px' viewBox='0 0 27 17' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 52.5 (67469) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3Eslider arrow copy 2%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Program-D-Math' transform='translate(-1039.000000, -3726.000000)' fill='%234D4D4A' stroke='%234D4D4A' stroke-width='1.96'%3E%3Cg id='slider-arrow' transform='translate(1052.500000, 3734.000000) rotate(-90.000000) translate(-1052.500000, -3734.000000) translate(1044.500000, 3721.500000)'%3E%3Cpath d='M13.5324837,24.8310811 C13.312616,24.8310811 13.09215,24.7563214 12.9189481,24.6054125 L0.519904875,13.8072257 C0.189654598,13.5193037 0,13.0724132 0,12.5810559 C0,12.0896987 0.189654598,11.6428081 0.519904875,11.3548861 L12.9189481,0.556699337 C13.2803089,0.241541468 13.8483753,0.258772321 14.1873006,0.594496048 C14.526226,0.930497691 14.5079784,1.45826206 14.1463185,1.77314201 L2.68089039,11.7586995 C2.16936142,12.2039226 2.16936142,12.9581893 2.68089039,13.4034123 L14.1463185,23.3892477 C14.5079784,23.7038498 14.526226,24.2316141 14.1873006,24.5676158 C14.0108082,24.7427035 13.7717955,24.8310811 13.5324837,24.8310811' id='Fill-1'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A"
            data-state
          >
        </div>
      </div>
      <!-- End .tcu-program-filter-list -->
      <div class="tcu-program-filter-view tcu-visually-hidden">
        <p class="filter _view">
          <a v-bind:class="{ 'active': layout == 'grid'}" v-on:click="gridView">
            View Grid
            <img
              height="10"
              width="10"
              alt="Open Accordion"
              class="tcu-down-arrow"
              src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 21.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 12 12' style='enable-background:new 0 0 12 12;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23111111;%7D%0A%3C/style%3E%3Ctitle%3EGroup%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1'%3E%3Cg id='Program-List-links' transform='translate(-1468.000000, -545.000000)'%3E%3Cg id='Group' transform='translate(1468.000000, 545.000000)'%3E%3Crect id='Rectangle' class='st0' width='5' height='5'/%3E%3Crect id='Rectangle_1_' y='7' class='st0' width='5' height='5'/%3E%3Crect id='Rectangle_2_' x='7' class='st0' width='5' height='5'/%3E%3Crect id='Rectangle_3_' x='7' y='7' class='st0' width='5' height='5'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A"
            >
          </a>
        </p>
        <p class="filter _view">
          <a v-bind:class="{ 'active': layout == 'list'}" v-on:click="listView">
            View List
            <img
              height="15"
              width="15"
              alt="Open Accordion"
              class="tcu-down-arrow"
              src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 21.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 16 10' style='enable-background:new 0 0 16 10;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:none;stroke:%23111111;stroke-linecap:square;%7D%0A%3C/style%3E%3Ctitle%3EGroup 3%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1'%3E%3Cg id='Program-List-links' transform='translate(-1637.000000, -545.000000)'%3E%3Cg id='Group-3' transform='translate(1638.000000, 545.000000)'%3E%3Cpath id='Line' class='st0' d='M4,0.5h10'/%3E%3Cpath id='Line_1_' class='st0' d='M0,0.5h1'/%3E%3Cpath id='Line_2_' class='st0' d='M4,3.5h10'/%3E%3Cpath id='Line_3_' class='st0' d='M0,3.5h1'/%3E%3Cpath id='Line_4_' class='st0' d='M4,6.5h10'/%3E%3Cpath id='Line_5_' class='st0' d='M0,6.5h1'/%3E%3Cpath id='Line_6_' class='st0' d='M4,9.5h10'/%3E%3Cpath id='Line_7_' class='st0' d='M0,9.5h1'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A"
            >
          </a>
        </p>
      </div>
    </header>

    <hr>

    <div class="tcu-program-filters-menu tcu-fadeIn" data-state>
      <div class="close-filter-menu">X</div>

      <div class="tcu-checkbox-list">
        <p>
          <strong>Undergraduate</strong>
        </p>
        <ul id="checkboxes-degrees">
          <li v-for="(degree, index) in degrees" :key="index" class="form-check">
            <input
              v-bind:id="'do' + index"
              class="form-check-input"
              type="checkbox"
              v-model="degree.checked"
              v-on:change="getfilteredData"
            >
            <label class="form-check-label" v-bind:for="'do' + index">{{ degree.label }}</label>
          </li>
        </ul>
        <p>
          <strong>Graduate</strong>
        </p>
        <ul id="checkboxes-graddegrees">
          <li v-for="(graddegree, index) in graddegrees" :key="index" class="form-check">
            <input
              v-bind:id="'gd' + index"
              class="form-check-input"
              type="checkbox"
              v-model="graddegree.checked"
              v-on:change="getfilteredData"
            >
            <label class="form-check-label" v-bind:for="'gd' + index">{{ graddegree.label }}</label>
          </li>
        </ul>
        <input
          id="show-all-degrees"
          class="form-check-input"
          type="checkbox"
          v-on:change="clearDegreeFilters"
          v-model="isShowAllDegrees"
        >
        <label class="form-check-label" for="show-all-degrees">Show All</label>
      </div>
      <!-- End .tcu-checkbox-list -->
      <div class="tcu-checkbox-list _double">
        <p>
          <strong>Career Interest</strong>
        </p>
        <ul id="checkboxes-career">
          <li v-for="(career, index) in careers" :key="index" class="form-check">
            <input
              v-bind:id="'ci' + index"
              class="form-check-input"
              type="checkbox"
              v-model="career.checked"
              v-on:change="getfilteredData"
            >
            <label class="form-check-label" v-bind:for="'ci' + index">{{ career.label }}</label>
          </li>
          <li>
            <br>
            <input
              id="show-all-careers"
              class="form-check-input"
              type="checkbox"
              v-on:change="clearCareerFilters"
              v-model="isShowAllCareers"
            >
            <label class="form-check-label" for="show-all-careers">Show All</label>
          </li>
        </ul>
      </div>
      <!-- End .tcu-checkbox-list -->
      <div class="tcu-checkbox-list">
        <p>
          <strong>College/School</strong>
        </p>
        <ul id="checkboxes-school">
          <li v-for="(school, index) in schools" :key="index" class="form-check">
            <input
              v-bind:id="'cs' + index"
              class="form-check-input"
              type="checkbox"
              v-model="school.checked"
              v-on:change="getfilteredData"
            >
            <label class="form-check-label" v-bind:for="'cs' + index">{{ school.label }}</label>
          </li>
        </ul>
        <input
          id="show-all-schools"
          class="form-check-input"
          type="checkbox"
          v-on:change="clearSchoolFilters"
          v-model="isShowAllSchools"
        >
        <label class="form-check-label" for="show-all-schools">Show All</label>
      </div>
      <!-- End .tcu-checkbox-list -->
    </div>
    <div v-if="true === loaded && 1 > filteredData.length" class="tcu-alert _help">
      <p>No programs match your current filter selections.</p>
    </div>
    <div v-if="false === loaded">
      <p>Please wait while we fetch our program information for you.</p>
    </div>
    <!-- End .tcu-program-filters-menu -->
    <div v-if="layout === 'grid'" class="tcu-card-wrap _grid tcu-fadeIn">
      <!-- iterate data -->
      <academic-card
        v-for="(card, index) in filteredData"
        :key="index"
        :card="card"
        v-model="layout"
      ></academic-card>
    </div>

    <div v-if="layout === 'list'" class="tcu-program-list tcu-fadeIn">
      <ul class="tcu-program-list-a">
        <academic-list
          v-for="(list, index) in filteredData"
          :key="index"
          v-model="layout"
          :list="list"
        ></academic-list>
      </ul>
    </div>
    <!-- End .tcu-program-list group -->
  </div>
  <!-- End .tcu-article._content .tcu-full-width -->
</template>

<script>
import AcademicCard from "./AcademicCard";
import AcademicList from "./AcademicList";
import axios from "axios";

export default {
  name: "FilteredContent",
  components: {
    "academic-card": AcademicCard,
    "academic-list": AcademicList
  },
  computed: {
    selectedSchools: function() {
      let schoolFilters = [];
      let checkedFilters = this.schools.filter(obj => obj.checked);
      checkedFilters.forEach(element => {
        schoolFilters.push(element.value);
      });
      return schoolFilters;
    },
    selectedCareers: function() {
      let careerFilters = [];
      let checkedFilters = this.careers.filter(obj => obj.checked);
      checkedFilters.forEach(element => {
        careerFilters.push(element.value);
      });
      return careerFilters;
    },
    selectedDegrees: function() {
      let degreeFilters = [];
      let checkedFilters = this.degrees.filter(obj => obj.checked);
      checkedFilters.forEach(element => {
        degreeFilters.push(element.value);
      });
      return degreeFilters;
    },
    selectedGradDegrees: function() {
      let gradDegreeFilters = [];
      let checkedFilters = this.graddegrees.filter(obj => obj.checked);
      checkedFilters.forEach(element => {
        gradDegreeFilters.push(element.value);
      });
      return gradDegreeFilters;
    }
  },
  data() {
    return {
      loaded: false,
      liveProgData: {
        programs: [
          {
            name: "Program Name",
            schools: "honors",
            degrees: "bachelor",
            graddegrees: "doctorate",
            degreetext: "BS, PhD",
            career: "healthcare",
            keywords: "keyword",
            cardimg: {
              img: {
                _src: "/academics/images/cards/AGACNP.jpg",
                _alt: "placeholder",
                _width: "600",
                _height: "480"
              }
            },
            _href:
              "/academics/programs/adult-gerontology-acute-care-nurse-practitioner.php"
          }
        ]
      },
      search: "",
      filteredData: [],
      isShowAllDegrees: true,
      isShowAllCareers: true,
      isShowAllSchools: true,
      layout: "grid",
      careers: [
        {
          checked: false,
          label: "Accounting",
          value: "accounting"
        },
        {
          checked: false,
          label: "Advertising/Marketing",
          value: "advertising"
        },
        {
          checked: false,
          label: "Aerospace",
          value: "aerospace"
        },
        {
          checked: false,
          label: "Agriculture",
          value: "agriculture"
        },
        {
          checked: false,
          label: "Architecture/Interior Design",
          value: "architecture"
        },
        {
          checked: false,
          label: "Arts & Entertainment/Recreation",
          value: "arts"
        },
        {
          checked: false,
          label: "Beauty & Cosmetics",
          value: "beauty"
        },
        {
          checked: false,
          label: "Chemical",
          value: "chemical"
        },
        {
          checked: false,
          label: "Communications/Public Relations",
          value: "communications"
        },
        {
          checked: false,
          label: "Construction",
          value: "construction"
        },
        {
          checked: false,
          label: "Consulting",
          value: "consulting"
        },
        {
          checked: false,
          label: "Consumer Products",
          value: "consumer"
        },
        {
          checked: false,
          label: "Education",
          value: "education"
        },
        {
          checked: false,
          label: "Energy",
          value: "energy"
        },
        {
          checked: false,
          label: "Engineering",
          value: "engineering"
        },
        {
          checked: false,
          label: "Fashion",
          value: "fashion"
        },
        {
          checked: false,
          label: "Financial Services",
          value: "financial"
        },
        {
          checked: false,
          label: "Food & Beverage",
          value: "food"
        },
        {
          checked: false,
          label: "Government Services",
          value: "government"
        },
        {
          checked: false,
          label: "Health & Fitness",
          value: "health"
        },
        {
          checked: false,
          label: "Health Care",
          value: "healthcare"
        },
        {
          checked: false,
          label: "Hospitality",
          value: "hospitality"
        },
        {
          checked: false,
          label: "Insurance",
          value: "insurance"
        },
        {
          checked: false,
          label: "Legal Services",
          value: "legal"
        },
        {
          checked: false,
          label: "Logistics/Distribution",
          value: "logistics"
        },
        {
          checked: false,
          label: "Manufacturing",
          value: "manufacturing"
        },
        {
          checked: false,
          label: "Media & Broadcasting",
          value: "media"
        },
        {
          checked: false,
          label: "Non-Profit",
          value: "nonprofit"
        },
        {
          checked: false,
          label: "Real Estate",
          value: "realestate"
        },
        {
          checked: false,
          label: "Retail",
          value: "retail"
        },
        {
          checked: false,
          label: "Sports",
          value: "sports"
        },
        {
          checked: false,
          label: "Technology",
          value: "technology"
        }
      ],
      degrees: [
        {
          checked: false,
          label: "Bachelor",
          value: "bachelor"
        },
        {
          checked: false,
          label: "Minor",
          value: "minor"
        },
        {
          checked: false,
          label: "Certificate",
          value: "certificate"
        }
      ],
      graddegrees: [
        {
          checked: false,
          label: "Doctorate",
          value: "doctorate"
        },
        {
          checked: false,
          label: "Master",
          value: "master"
        },
        {
          checked: false,
          label: "Graduate Certificate",
          value: "gradcert"
        }
      ],
      schools: [
        {
          checked: false,
          label: "AddRan College of the Liberal Arts",
          value: "addran"
        },
        {
          checked: false,
          label: "Bob Schieffer College of Communication",
          value: "communication"
        },
        {
          checked: false,
          label: "College of Education",
          value: "education"
        },
        {
          checked: false,
          label: "College of Fine Arts",
          value: "finearts"
        },
        {
          checked: false,
          label: "College of Science & Engineering",
          value: "science"
        },
        {
          checked: false,
          label: "Harris College of Nursing & Health Sciences",
          value: "harris"
        },
        {
          checked: false,
          label: "John V. Roach Honors College",
          value: "honors"
        },
        {
          checked: false,
          label: "Neeley School of Business",
          value: "neeley"
        }
      ]
    };
  },
  methods: {
    toggleState(elem, one, two) {
      elem = document.querySelector(elem);
      elem.setAttribute(
        "data-state",
        elem.getAttribute("data-state") === one ? two : one
      );
    },
    popState: function() {
      // check for any query string params
      this.checkForParams();
      this.getfilteredData();
    },
    setUpHandlers: function() {
      const filterMenuLabel = document.querySelector(
        ".tcu-program-filter-list .filter._label"
      );
      const filterMenuCloseBtn = document.querySelector(".close-filter-menu");

      if ("undefined" != filterMenuLabel) {
        filterMenuLabel.addEventListener("click", e => {
          let elementClicked = e.target;

          this.toggleState(".tcu-program-filters-menu", "", "active");
          this.toggleState(".filter._label img", "", "active");

          e.preventDefault();
        });

        if ("undefined" !== filterMenuCloseBtn) {
          filterMenuCloseBtn.addEventListener("click", e => {
            let elementClicked = e.target;
            this.toggleState(".tcu-program-filters-menu", "", "active");
            this.toggleState(".filter._label img", "", "active");
            e.preventDefault();
          });
        }
      }

      window.addEventListener("popstate", this.popState);
    },
    checkForParams: function() {
      let paramDegrees = [];
      let paramGradDegrees = [];
      let paramCareers = [];
      let paramSchools = [];
      let paramSearch = "";
      // check for degrees
      if (this.getURLParam("degrees").length > 0) {
        paramDegrees = this.getURLParam("degrees");
        this.degrees.forEach(function(el) {
          if (paramDegrees.includes(el.value)) {
            el.checked = true;
          }
        });
      }
      // check for graduate degrees
      if (this.getURLParam("graddegrees").length > 0) {
        paramGradDegrees = this.getURLParam("graddegrees");
        this.graddegrees.forEach(function(el) {
          if (paramGradDegrees.includes(el.value)) {
            el.checked = true;
          }
        });
      }
      // check for career interests
      if (this.getURLParam("careers").length > 0) {
        paramCareers = this.getURLParam("careers");
        this.careers.forEach(function(el) {
          if (paramCareers.includes(el.value)) {
            el.checked = true;
          }
        });
      }
      // check for colleges/schools
      if (this.getURLParam("schools").length > 0) {
        paramSchools = this.getURLParam("schools");
        this.schools.forEach(function(el) {
          if (paramSchools.includes(el.value)) {
            el.checked = true;
          }
        });
      }
      // check for search keyword
      if (this.getURLParam("s").length > 0) {
        this.search = this.getURLParam("s");
      }
    },
    getURLParam: function(variable) {
      let url = new URLSearchParams(document.location.search);
      let params = url.getAll(variable) || "";
      // If the param has a single value, return it as a string instead of an array
      if (params.length === 1 && params !== "") {
        params = params[0];
      }
      return params;
    },
    gridView: function() {
      this.layout = "grid";
    },
    listView: function() {
      this.layout = "list";
    },
    getfilteredData: function(e) {
      if (e && e.which === 13) {
        let searchTerm = this.search;
        let searchLink =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?s=" +
          searchTerm;

        history.pushState(null, null, searchLink);
      }
      this.filteredData = this.liveProgData.programs;
      let filteredDataByfilters = [];
      let filteredDataBySearch = [];
      let searchRegEx = "";
      // first, check if any degree options were selected
      if (this.selectedDegrees.length > 0) {
        filteredDataByfilters = this.filteredData.filter(obj =>
          this.selectedDegrees.some(val => obj.degrees.indexOf(val) >= 0)
        );
        this.filteredData = filteredDataByfilters;
        this.isShowAllDegrees = false;
      }
      // then check if any graduate degrees were selected
      if (this.selectedGradDegrees.length > 0) {
        filteredDataByfilters = this.filteredData.filter(obj =>
          this.selectedGradDegrees.some(
            val => obj.graddegrees.indexOf(val) >= 0
          )
        );
        this.filteredData = filteredDataByfilters;
        this.isShowAllDegrees = false;
      }
      if (
        1 > this.selectedDegrees.length &&
        1 > this.selectedGradDegrees.length
      ) {
        this.isShowAllDegrees = true;
      }
      // then check if any careers were selected
      if (this.selectedCareers.length > 0) {
        filteredDataByfilters = this.filteredData.filter(obj =>
          this.selectedCareers.some(val => obj.career.indexOf(val) >= 0)
        );
        this.filteredData = filteredDataByfilters;
        this.isShowAllCareers = false;
      } else {
        this.isShowAllCareers = true;
      }
      // then check if any schools were selected
      if (this.selectedSchools.length > 0) {
        filteredDataByfilters = this.filteredData.filter(obj =>
          this.selectedSchools.some(val => obj.schools.indexOf(val) >= 0)
        );
        this.filteredData = filteredDataByfilters;
        this.isShowAllSchools = false;
      } else {
        this.isShowAllSchools = true;
      }
      // then filter according to keyword
      if (this.search !== "") {
        let searchRegEx = new RegExp(this.search, "i");
        if (this.search.indexOf(" ") != -1) {
          let searchTerms = this.search.split(" ");
          let multiRE = "^";
          for (var st = 0; st < searchTerms.length; st++) {
            multiRE += "(?=.*" + searchTerms[st] + ")";
          }
          searchRegEx = new RegExp(multiRE, "i");
        }
        filteredDataBySearch = this.filteredData.filter(obj =>
          obj.keywords.match(searchRegEx)
        );
        this.filteredData = filteredDataBySearch;
      }
    },
    mergeKeywords: function() {
      // break the program title apart and add it to list of keywords
      let programs = this.liveProgData.programs;
      for (var i = 0; i < programs.length; i++) {
        let programTitle = programs[i].name.split(" ");
        let programKeywords = programs[i].keywords;

        for (var ii = 0; ii < programTitle.length; ii++) {
          programKeywords += programTitle[ii] + ",";
        }
        programs[i].keywords = programKeywords;
        // then tack on the degree text (BFA, MA, PhD)
        programs[i].keywords += "," + programs[i].degreetext;
      }
    },
    clearDegreeFilters: function() {
      if (
        0 < this.selectedDegrees.length ||
        0 < this.selectedGradDegrees.length
      ) {
        this.uncheckAll(this.degrees);
        this.uncheckAll(this.graddegrees);
      }
      this.isShowAllDegrees = true;
      this.getfilteredData();
    },
    clearCareerFilters: function() {
      if (0 < this.selectedCareers.length) {
        this.uncheckAll(this.careers);
      }
      this.isShowAllCareers = true;
      this.getfilteredData();
    },
    clearSchoolFilters: function() {
      if (0 < this.selectedSchools.length) {
        this.uncheckAll(this.schools);
      }
      this.isShowAllSchools = true;
      this.getfilteredData();
    },
    uncheckAll: function(collection) {
      collection.forEach(function(el) {
        el.checked = false;
      });
    }
  },
  mounted() {
    axios({
      method: "GET",
      url: "https://www.tcu.edu/academics/programs/index.json"
    }).then(
      result => {
        this.liveProgData = result.data;
        this.loaded = true;
        // merge title into keywords
        this.mergeKeywords();
        // check for any query string params
        this.checkForParams();
        this.getfilteredData();
      },
      error => {
        //console.error(error);
      }
    );
    if (localStorage.layout) {
      this.layout = localStorage.layout;
    }
    this.setUpHandlers();
  },
  watch: {
    layout(newLayout) {
      localStorage.layout = newLayout;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ProgramFinder.vue